import type { QueryClient } from "@tanstack/react-query";

/** A step may finish before the parent; refresh the open delivery read for its team. */
export function invalidateFirstAdDeliveries(client: QueryClient, teamId: string): Promise<void> {
  const prefix = `/api/v1/teams/${teamId}/brands/`;
  return client.invalidateQueries({
    predicate: ({ queryKey }) => typeof queryKey[0] === "string"
      && queryKey[0].startsWith(prefix)
      && (/\/first-ad-runs\/[^/]+\/delivery$/.test(queryKey[0])
        || /\/first-ad\/[^/]+$/.test(queryKey[0])),
  });
}
